import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';
// @ts-expect-error
import type {OptionProps} from 'react-select';

import {Body} from '../typography/body';

import styles from './option-with-subtitle-and-sublabel.module.css';

export function OptionWithSubtitleAndSublabel(props: OptionProps) {
    return (
        <components.Option {...props}>
            <div className='flex justify-sb align-start'>
                <div className={styles.content}>
                    <div className={styles.label}>{props.data.label}</div>
                    {props.data.sublabel && (
                        <Body size='tiny' truncate={{type: 'inline'}} color='light'>
                            {props.data.sublabel}
                        </Body>
                    )}
                </div>
                {props.data.subtitle && (
                    <div className={styles.subtitle}>{props.data.subtitle}</div>
                )}
            </div>
        </components.Option>
    );
}
